import type { HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Low-level shimmer placeholder. Size it with Tailwind width/height on the
 * caller side (`<Skeleton className="h-4 w-24" />`); the component just
 * handles the pulsing tone so every placeholder in the app looks the same.
 *
 * Use while an actual value is loading. Prefer `—` for truly-empty values
 * so the user can distinguish "loading" from "blank".
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
